import React from "react"

export const Svg = ({ children, ...props }: React.SVGProps<SVGSVGElement>) => (
  <svg {...props}>{children}</svg>
)
export const Path = (props: React.SVGProps<SVGPathElement>) => <path {...props} />
export const Circle = (props: React.SVGProps<SVGCircleElement>) => <circle {...props} />
export const Rect = (props: React.SVGProps<SVGRectElement>) => <rect {...props} />
export default Svg
